import {cn} from '@tempmee/core'
import {forwardRef} from 'react'
import {Box, type BoxProps} from './Box'
import {FlexVariantsFactory, buildGapClasses} from './Variants'
import type {SpacingScale} from './Variants'

export interface FlexProps extends BoxProps {
  /** Flex direction. @default undefined (inherits browser default: 'row') */
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  /** Align items along the cross axis. Maps to `align-items`. */
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline'
  /** Justify content along the main axis. Maps to `justify-content`. */
  justify?: 'start' | 'center' | 'end' | 'between'
  /** Flex wrap behaviour. */
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
  /** Gap between children (all directions). Uses the spacing scale (0–24). */
  gap?: SpacingScale
  /** Horizontal gap between children. Uses the spacing scale (0–24). */
  gapX?: SpacingScale
  /** Vertical gap between children. Uses the spacing scale (0–24). */
  gapY?: SpacingScale
}

export const Flex = forwardRef<HTMLDivElement, FlexProps>(
  ({className, direction, align, justify, wrap, gap, gapX, gapY, ...props}, ref) => {
    const flexClasses = FlexVariantsFactory({direction, align, justify, wrap})
    const gapClasses = buildGapClasses({gap, gapX, gapY})

    return <Box ref={ref} className={cn(flexClasses, gapClasses, className)} {...props} />
  },
)

Flex.displayName = 'Flex'
